<template>
  <div>
    <RankBar
      :chartData="chartData"
      rect="yes"
      proportion="yes"
      id="jingquziyuan"
    />
  </div>
</template>

<script>
import RankBar from "@/components/Mycharts/RankBar.vue";

export default {
  name: "JingquZiyuanFenxi",
  props: {
    chartData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
    RankBar
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less"></style>
